<template>
  <div class="login-page">
    <!-- 全屏背景视频（无遮罩、无间距、铺满屏幕） -->
    <video
      class="bg-video"
      src="https://mr-futrue.oss-accelerate.aliyuncs.com/PC/login-video.mp4"
      autoplay
      :muted="true"
      loop
      playsinline
      webkit-playsinline
      x5-playsinline
      preload="auto"
    ></video>

    <!-- 中间偏右的高斯模糊玻璃登录卡片 -->
    <div class="login-shell">
      <div class="glass-card">
        <!-- <p class="login-title">纯璟泉智慧水务企业后台管理系统</p> -->
        <!-- <p class="login-title">云术智慧水订单管理系统</p> -->
        <el-form
          :model="loginForm"
          :rules="rules"
          ref="loginForm"
          class="login-container"
        >
          <h3 class="title">欢迎登录平台</h3>
          <el-form-item prop="user_login">
            <el-input
              id="input2"
              v-model="loginForm.user_login"
              auto-complete="off"
              placeholder="请输入11位手机号"
              :maxlength="11"
            >
              <i slot="prefix" class="el-input__icon el-icon-mobile-phone"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="user_password">
            <el-input
              id="input2"
              type="password"
              v-model="loginForm.user_password"
              auto-complete="off"
              show-password
              placeholder="请输入密码"
            >
              <i slot="prefix" class="el-input__icon el-icon-lock"></i>
            </el-input>
          </el-form-item>
          <div class="verification_code">
            <el-form-item prop="verification_code">
              <div class="code-input">
                <el-input
                  id="input2"
                  v-model="loginForm.verification_code"
                  auto-complete="off"
                  placeholder="验证码"
                  @keyup.enter.native="submitForm('loginForm')"
                >
                  <i
                    slot="prefix"
                    class="el-input__icon el-icon-edit-outline"
                  ></i>
                </el-input>
              </div>
              <div class="verification-code-box flex-1">
                <img :src="codeSrc" alt="" @click="changeImg" />
              </div>
            </el-form-item>
          </div>
          <!-- <div class="checkbox">
            <el-checkbox v-model="checked" @change="gofbuk"
              >记住账号</el-checkbox
            >
          </div> -->
          <el-form-item class="center">
            <button
              style="width:100%"
              class="btnlogin"
              type="primary"
              @click.prevent="submitForm('loginForm')"
            >
              登录
            </button>
          </el-form-item>
          <!-- <p class="login-code" @click="hreftwo">验证码登录</p> -->
          <div class="tr">
            <div class="forgetPassword" @click="getwangji">
              忘记密码?
            </div>
          </div>
        </el-form>
      </div>
    </div>

    <!-- 底部版权信息 -->
    <div class="biaoshi flex aic">
      @ 2005-{{ new Date().getFullYear() }}
      <div class="urlMr mgl-5" @click.prevent="tiaozhuan">
        MR.FUTURE未来先生
      </div>
      版权所有，并保留所有权 | 蜀CP备2021032368号-2
    </div>
  </div>
</template>

<script>
//import NProgress from 'nprogress'
import { validateMobilePhone, validatePass, validateCode } from "../utils/tool";
import jsonp from "jsonp";
import md5 from "js-md5";
export default {
  data() {
    // 登录密码
    const addPwd = (rule, value, callback) => {
      var reg = /^[a-zA-Z0-9]{6,12}$/;
      if (!value) {
        callback(new Error("请填写登录密码"));
      } else if (!reg.test(value)) {
        callback(new Error("密码只能输入数字和字母，长度在6~12位"));
      } else {
        callback();
      }
    };
    return {
      logining: false,
      loginForm: {
        user_login: "",
        user_password: "",
        verification_code: "",
      },
      rules: {
        user_login: [
          { required: true, message: "请输入账号", trigger: "blur" },
          { validator: validateMobilePhone, trigger: "blur" },
        ],
        user_password: [
          // { required: true, message: "请输入密码", trigger: "blur" },
          { required: true, validator: addPwd, trigger: "blur" },
        ],
        verification_code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      },
      checked: false,
      codeSrc: "",
    };
  },
  created() {
    var adso = localStorage.getItem("userlogins");

    this.loginForm.user_login = adso;

    this.getCode();
  },
  methods: {
    tiaozhuan() {
      window.open("https://iot.mr-future.com/#/Login", "_blank");
    },
    getwangji() {
      this.$router.push("/getCode");
    },
    changeImg() {
      this.getCode();
    },

    // 记住账号

    gofbuk() {
      if (this.checked == true) {
        localStorage.setItem("userlogins", this.loginForm.user_login);

        console.log(this.loginForm.user_login);
      } else if (this.checked == false) {
        localStorage.removeItem("userlogins");
      }

      console.log(this.checked);
    },
    // 生成验证码
    getCode() {
      this.$api.admincustomerq.getCodeImage().then((res) => {
        let blob = new Blob([res], { type: "image/png" });
        let url = window.URL.createObjectURL(blob);
        this.codeSrc = url;
      });
    },

    hreftwo() {
      this.$router.push({ path: "yanzhengma" });
    },
    handleReset() {
      this.$refs.loginForm.resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (formName == "loginForm") {
            //用户登录
            this.$api.admincustomer
              .customerlogin({
                phone: this.loginForm.user_login,
                password: this.loginForm.user_password, //md5()
                imageCode: this.loginForm.verification_code,
              })
              .then((d) => {
                if (d.code == 200) {
                  this.$store.dispatch("set_token", d.data);
                  console.log(d.data, "d.data");
                  console.log(d.data.sceneInfo, "d.data555");

                  if (d.data.sceneInfo.length > 0) {
                    localStorage.setItem(
                      "sceneInfo",
                      JSON.stringify(d.data.sceneInfo)
                    );
                    if (d.data.sceneInfo.length > 1) {
                      this.$router.push("/sceneSelect");
                    } else {
                      window.sessionStorage["sceneId"] = Number(
                        d.data.sceneInfo[0]
                      );
                      window.sessionStorage["sceneName"] =
                        Number(d.data.sceneInfo[0]) === 1
                          ? "景区场景"
                          : Number(d.data.sceneInfo[0]) == 2
                          ? "校园场景"
                          : "社区场景";
                      this.$api.system
                        .sceneChange({
                          sceneId: Number(d.data.sceneInfo[0]),
                          sceneName:
                            Number(d.data.sceneInfo[0]) === 1
                              ? "景区场景"
                              : Number(d.data.sceneInfo[0]) == 2
                              ? "校园场景"
                              : "社区场景",
                        })
                        .then((res) => {
                          this.$router.push("/");
                        });
                    }
                  }
                } else {
                  this.$message.error(d.message);
                }
              })
              .catch((e) => {
                // eslint-disable-next-line no-console
                console.log(e);
              });
          } else {
            this.next();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    info() {
      this.$api.admincustomer
        .customerinfo({})
        .then((d) => {
          // console.log('sdafsdf', d);
          if (d.code == 200) {
            // console.log(d.data);
            this.$store.dispatch("set_token", d.data.token);
            this.$$store.dispatch("set_roleId", d.data.roleId);
            this.$router.push("/");
          } else {
            this.$message.error(d.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>

<style lang="scss">
/* ===== 登录/忘记密码页字体：系统字体统一栈（2026-07-08 去掉阿里巴巴普惠体——Windows 未安装、只是摆设）=====
   .login-page 页面与 .title/.btnlogin 现在用同一个 $puhui（$puhui-display 指向它），字体完全统一。
   Mac 命中 PingFang SC，Windows 命中微软雅黑；标题/按钮再叠 font-weight:300 走 Light 细体，
   "Microsoft YaHei Light" 前置：支持的 Chrome 直接用雅黑 Light face（对 Windows 变细是双保险）。 */
$puhui: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei Light", "微软雅黑 Light",
  "Microsoft YaHei", "微软雅黑", sans-serif;
$puhui-display: $puhui;

/* 所有样式收拢在 .login-page 之下，避免非 scoped 样式污染其它页面 */
.login-page {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  font-family: $puhui;
  -webkit-font-smoothing: antialiased; /* Mac 抗锯齿更细腻，配合 300 字重（Windows 用 DirectWrite 不受此属性影响）*/
  -moz-osx-font-smoothing: grayscale;
  /* 响应式基准单位（2026-07-08）：1920 宽时 = 1px，随视口宽度等比缩放，带上下限。
     卡片/输入框/间距/字体一律 calc(N * var(--px)) 跟随，整卡等比缩放。
     以 1920 为基准合适，Mac 等较小视口自动缩小、不再显大；不改全局 html 根字号（不影响后台）。 */
  --px: clamp(0.7px, 0.05208vw, 1.12px);

  /* ===== 全屏背景视频：铺满、无遮罩、无间距 ===== */
  .bg-video {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    object-fit: cover;
    z-index: 0;
    margin: 0;
    padding: 0;
    border: none;
    display: block;
    pointer-events: none;
  }

  /* ===== 卡片容器：占据右半屏，卡片在其中水平垂直居中（卡片中心 = 视口 75% 处） ===== */
  .login-shell {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    width: 50%;
    height: 100%;
    display: flex;
    align-items: center; /* 垂直居中 */
    justify-content: center; /* 右半屏内水平居中 */
    padding: 0 calc(24 * var(--px));
    box-sizing: border-box;
  }

  /* ===== 高斯模糊玻璃卡片：圆角、透明、简约（尺寸随 --px 等比缩放） ===== */
  .glass-card {
    width: 100%;
    max-width: calc(420 * var(--px)); /* 1920→420px，随视口等比缩放 */
    padding: calc(36 * var(--px)) calc(32 * var(--px)) calc(32 * var(--px));
    box-sizing: border-box;

    background: rgba(255, 255, 255, 0.3);
    -webkit-backdrop-filter: blur(26px) saturate(150%);
    backdrop-filter: blur(26px) saturate(150%);
    border-radius: calc(20 * var(--px));
    border: 1px solid rgba(255, 255, 255, 0.55);
    box-shadow: 0 20px 60px rgba(8, 44, 92, 0.28),
      inset 0 1px 0 rgba(255, 255, 255, 0.6);
    animation: cardIn 0.7s cubic-bezier(0.22, 1, 0.36, 1) both;
  }

  /* el-form 本身透明，让玻璃质感透出来 */
  .login-container {
    width: 100%;
    background: transparent;
    box-sizing: border-box;

    /* 标题：白色、细字重（2026-07 定版由品牌蓝改白） */
    .title {
      font-family: $puhui-display;
      font-size: calc(26 * var(--px));
      font-weight: 300; /* 雅黑/苹方各自的 Light 字重，两平台一致（400 会命中雅黑 Regular，Windows 明显偏粗）*/
      letter-spacing: calc(0.5 * var(--px));
      white-space: nowrap;
      text-align: center;
      margin: 0 auto calc(32 * var(--px));
      color: #fff;
    }

    .el-form-item {
      margin-bottom: calc(25 * var(--px)); /* 预留下方校验提示的空间：25 = 上6 + 提示13 + 下6，提示上下间距一致 */
    }
    /* 校验提示：定位使其在预留空间里上下间距一致（上 6px、下 6px）*/
    .el-form-item__error {
      position: absolute;
      top: 100%;
      left: 0;
      padding-top: calc(6 * var(--px));
      line-height: 1;
      color: rgba(255, 255, 255, 0.95); /* 校验提示白一点（原灰色看不清）；加投影保证在浅玻璃卡上清晰 */
      text-shadow: 0 1px 4px rgba(20, 40, 70, 0.5);
      font-size: calc(13 * var(--px));
      font-weight: 400;
    }
    .el-form-item__content {
      line-height: normal;
    }

    /* ===== 简洁胶囊输入框，视频背景上依旧清晰 =====
       注意：模板里的 id="input2" 会被 el-input 透传到原生 input 元素上（且多个输入框复用同一 id），
       #input2 的高度必须与 .el-input__inner 保持同值（50px），否则 id 权重（1,0,0）会压过类规则导致高度不齐。 */
    #input2 {
      height: calc(50 * var(--px));
    }

    .el-input__inner {
      height: calc(50 * var(--px));
      line-height: calc(50 * var(--px));
      border-radius: calc(26 * var(--px));
      border: 1px solid rgba(255, 255, 255, 0.7);
      background: rgba(255, 255, 255, 0.62); /* 原始半透明白（placeholder 恢复原样）*/
      color: #1a2b45;
      font-family: $puhui;
      font-size: calc(15 * var(--px));
      font-weight: 400;
      padding-left: calc(44 * var(--px));
      transition: all 0.25s ease;
      box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.04);

      &::placeholder {
        color: #5c6b82;
      }
      &:hover {
        background: rgba(255, 255, 255, 0.75);
        border-color: rgba(12, 113, 207, 0.5);
      }
      &:focus {
        background: rgba(255, 255, 255, 0.9);
        border-color: #0c71cf;
        box-shadow: 0 0 0 3px rgba(12, 113, 207, 0.18);
      }
    }

    .el-input__prefix {
      left: calc(14 * var(--px));
      display: flex;
      align-items: center;
    }
    .el-input__icon {
      color: #0c71cf;
      font-size: calc(18 * var(--px));
      line-height: calc(50 * var(--px));
    }
    /* 显示密码的眼睛图标 */
    .el-input__suffix {
      right: calc(8 * var(--px));
    }
    .el-input__suffix .el-input__icon {
      font-size: calc(16 * var(--px));
      color: #5c6b82;
    }
  }

  /* ===== 验证码一行 ===== */
  .verification_code {
    margin-bottom: calc(22 * var(--px));

    .el-form-item__content {
      display: flex;
      align-items: center;
      justify-content: space-between !important;
    }
    .code-input {
      flex: 1;
      margin-right: calc(12 * var(--px));
    }
    /* 让验证码输入框铺满剩余空间，而不是塌缩到内容宽度 */
    .code-input .el-input {
      width: 100%;
    }
    .code-input .el-input__inner {
      width: 100%;
    }

    .verification-code-box {
      width: calc(146 * var(--px)); /* 与输入框同比例缩放；146×50 是 3:1（内容区 144=48×3）左右上下都无留白 */
      flex: 0 0 calc(146 * var(--px)); /* 同权压回模板公共类 flex-1（否则图块被撑满剩余宽度）*/
      height: calc(50 * var(--px)); /* 与输入框同高 */
      box-sizing: border-box;
      flex-shrink: 0;
      border-radius: calc(14 * var(--px));
      overflow: hidden;
      border: 1px solid rgba(255, 255, 255, 0.7);
      background: #fff; /* 白底：验证码图 contain 后的留白与图本身底色一致，看着是整张图 */

      img {
        width: 100%;
        height: 100%;
        object-fit: contain; /* contain 完整显示整张验证码（cover 会裁掉两端字符导致看不清）*/
        image-rendering: -webkit-optimize-contrast; /* 后端验证码原图很小，放大后做对比优化让高对比字符更锐利 */
        cursor: pointer;
        display: block;
      }
    }
  }

  /* ===== 登录按钮（30px / 400，2026-07 定版） ===== */
  .center {
    margin-bottom: calc(14 * var(--px)) !important;
  }
  .btnlogin {
    width: 100%;
    height: calc(54 * var(--px));
    margin-top: calc(4 * var(--px));
    font-family: $puhui-display;
    font-size: calc(30 * var(--px));
    font-weight: 400; /* 按钮用 400（比标题略重、更清晰有力）；标题仍 300 */
    letter-spacing: calc(4 * var(--px));
    color: #292929;
    border: none;
    cursor: pointer;
    border-radius: calc(26 * var(--px));
    background: linear-gradient(135deg, #e2e7ec 0%, #c6e5e4 55%, #93b7dc 100%);
    box-shadow: 0 10px 24px rgba(20, 60, 110, 0.22);
    transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;

    &:hover {
      filter: brightness(1.04);
      box-shadow: 0 14px 30px rgba(20, 60, 110, 0.3);
      transform: translateY(-1px);
    }
    &:active {
      transform: translateY(0);
      box-shadow: 0 6px 16px rgba(20, 60, 110, 0.22);
    }
  }

  /* ===== 忘记密码链接：突出、有间距 ===== */
  .tr {
    display: flex;
    justify-content: flex-end;
    margin-top: 4px;
  }
  .forgetPassword {
    font-family: $puhui;
    font-size: calc(15 * var(--px));
    font-weight: 400;
    letter-spacing: calc(1 * var(--px));
    color: #fff; /* 2026-07-08 定版：白色（原品牌蓝） */
    cursor: pointer;
    padding: calc(8 * var(--px)) calc(4 * var(--px));
    position: relative;
    transition: color 0.2s ease;

    &::after {
      content: "";
      position: absolute;
      left: 4px;
      bottom: 4px;
      width: 0;
      height: 2px;
      border-radius: 2px;
      background: #fff;
      transition: width 0.25s ease;
    }
    &:hover {
      color: rgba(255, 255, 255, 0.85);
    }
    &:hover::after {
      width: calc(100% - 8px);
    }
  }

  /* ===== 底部版权信息：视频上清晰、突出、有间距（qiye：内含可点击的 MR.FUTURE 链接，保持可交互） ===== */
  .biaoshi {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 28px;
    z-index: 3;
    justify-content: center; /* 模板是 flex 容器（flex aic），text-align 对 flex 项无效，用 justify-content 居中 */
    text-align: center;
    font-family: $puhui;
    font-size: calc(14 * var(--px));
    font-weight: 400;
    letter-spacing: calc(1 * var(--px));
    line-height: 1.9;
    color: rgba(255, 255, 255, 0.92);
    text-shadow: 0 1px 6px rgba(0, 0, 0, 0.55);
    padding: 0 20px;

    /* MR.FUTURE 链接：在版权行里突出 + 两侧留间距 */
    .urlMr {
      margin: 0 calc(8 * var(--px));
      padding: 0 calc(2 * var(--px));
      color: #cfe6ff;
      font-weight: 500;
      text-decoration: underline;
      text-underline-offset: 3px;
      cursor: pointer;
      transition: color 0.2s ease;
    }
    .urlMr:hover {
      color: #ffffff;
    }
  }

  /* 中和 Chrome 自动填充的黄色背景，保持透明胶囊输入框外观 */
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0 1000px rgba(255, 255, 255, 0.62) inset;
    -webkit-text-fill-color: #1a2b45;
    caret-color: #1a2b45;
    transition: background-color 9999s ease-in-out 0s;
  }
}

/* ===== 卡片入场动画 ===== */
@keyframes cardIn {
  from {
    opacity: 0;
    transform: translateY(18px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ===== 响应式：窄屏时右半屏放不下卡片，退回全屏居中 ===== */
@media (max-width: 900px) {
  .login-page .login-shell {
    width: 100%;
    justify-content: center;
    padding: 0 24px;
  }
  .login-page .login-container .title {
    font-size: calc(22 * var(--px));
    white-space: normal;
  }
}
/* 矮窗口：用 max-height 收紧留白（只压卡片 padding 和标题间距；
   不压 el-form-item 的 margin-bottom——否则下方校验提示会被挤没） */
@media (max-height: 720px) {
  .login-page .glass-card {
    padding-top: 26px;
    padding-bottom: 24px;
  }
  .login-page .login-container .title {
    margin-bottom: 24px;
  }
}
</style>
